export const emojis = [
  '🤩',
  '🫡',
  '🤯',
  '🤠',
  '🥳',
  '😎',
  '🥹',
  '🤖',
  '👽',
  '👻',
  '😸',
  '😸',
  '👧',
  '👨',
  '🧔‍♂️',
  '👩',
  '👩‍🦰',
  '👩‍🦳',
  '👱‍♀️',
  '👱‍♂️',
  '🙋',
  '🙋‍♀️',
  '👨‍⚕️',
  '👩‍⚕️',
  '🧑‍🏫',
  '👩‍🎓',
  '👨‍🎓',
  '👨‍⚖️',
  '👩‍⚖️',
  '👩‍🌾',
  '👨‍🌾',
  '👩‍🔧',
  '👩‍💼',
  '🧑‍🔬',
  '👩‍🔬',
  '👨‍💻',
  '👩‍💻',
  '🧑‍🎤',
  '👨‍🎤',
  '👩‍🎤',
  '👨‍✈️',
  '👩‍✈️',
  '🧑‍🚀',
  '👨‍🚀',
  '🧑‍🚒',
  '👨‍🚒',
  '👮',
  '🕵',
  '👷',
  '👷‍♂️',
  '👷‍♀️',
  '👸',
  '👳‍♂️',
  '👲',
  '🧕',
  '🎅',
  '🤶',
  '🧑‍🎄',
  '🦸',
  '🦸‍♀️',
  '🧙',
  '🧙‍♀️',
  '🧛',
  '🧛‍♂️',
  '🧛‍♀️',
  '🧜‍♂️',
  '🧜‍♀️',
  '🧞',
  '🧝‍♀️',
  '💆‍♀️',
  '💆',
  '🏃‍♂️',
  '💃',
  '🕺',
  '🧗‍♀️',
  '🧗',
  '🧗‍♂️',
  '🤺',
  '🏇',
  '⛷',
  '🏂',
  '🏌',
  '🏌️‍♂️',
  '🏄',
  '🏄‍♀️',
  '🚣',
  '🏊',
  '⛹',
  '⛹️‍♀️',
  '🏋',
  '🚴',
  '🏋️‍♀️',
  '🚵',
  '🤸',
  '🤽',
  '🤽‍♀️',
  '🤹',
  '🤹‍♀️',
  '🤹‍♂️',
  '🧘‍♀️',
  '🛌',
  '🧘‍♂️',
  '🐱',
  '🦝',
  '🦊',
  '🐶',
  '🐯',
  '🦁',
  '🐎',
  '🐭',
  '🐻‍❄️',
  '🐨',
  '🐼',
  '🐥',
  '🐦',
  '🐧',
  '🐢',
  '🦭',
  '🐙',
  '🦋',
  '🐝',
  '🐞',
  '🦠',
  '🚀',
  '🪂',
  '🛩',
  '🎸',
  '🦹',
];
